module.exports = __webpack_public_path__ + "fa-solid-900.00ddaede094b83270cad";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/scss/webfonts/fa-solid-900.ttf
// module chunks = styles